export enum MessageType {
    info = 'info',
    error = 'error',
}
